import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '../../utils';
import { Icon } from '../Icon';
// StepIconHorizontal
export function StepIconHorizontal(props) {
    const { active, completed, checkmark } = props;
    return (_jsx(StepIconHorizontalStyled, { active: active, completed: completed, children: checkmark && completed ? (_jsx(Icon, { fontSize: "small", variant: "check" })) : (props.icon) }));
}
const StepIconHorizontalStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'active' && prop !== 'completed',
})(({ theme, active, completed }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24, // NOTE: margin of the connector seems to be 12px
    height: 24,
    ...theme.typography.subtitle1,
    color: theme.palette.white.dark,
    fontFamily: theme.typography.fontFamily,
    ...(active && {
        color: theme.palette.primary.lighter,
    }),
    ...(completed && {
        color: theme.typography.body1.color,
    }),
}));
// StepIconVertical
export function StepIconVertical(props) {
    const { active, completed, checkmark } = props;
    return (_jsx(StepIconVerticalStyled, { active: active, children: checkmark && completed ? (_jsx(Icon, { fontSize: "medium", variant: "check" })) : (props.icon) }));
}
const StepIconVerticalStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'active',
})(({ theme, active }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24, // NOTE: margin of the connector seems to be 12px
    height: 24,
    ...theme.typography.subtitle1,
    ...(active && {
        ...theme.typography.h4,
        color: theme.palette.primary.lighter,
    }),
}));
